import React from "react";
import "../styles/OurCoreValues.css";
import HomePageContent from "./HomePageContent";
import honest from "../../../Images/Honesty_Image.png";
import innovate from "../../../Images/Innovate_Image.png";
import strength from "../../../Images/Strength_Image.png";
import customer from "../../../Images/Customer_Image.png";
import execute from "../../../Images/Execute_Image.png";
import lead from "../../../Images/Lead_Image.png";
import passion from "../../../Images/Passion_Image.png";

const coreValuesData = [
  { img: honest, title: HomePageContent.honesty_and_integrity_Title, content: HomePageContent.honesty_and_integrity_Content },
  { img: innovate, title: HomePageContent.innovate_relentlessly_Title, content: HomePageContent.innovate_relentlessly_Content },
  { img: strength, title: HomePageContent.strength_in_resiliency_Title, content: HomePageContent.strength_in_resiliency_Content },
  { img: customer, title: HomePageContent.Customer_Centric_focus_Title, content: HomePageContent.Customer_Centric_focus_Content },
  { img: execute, title: HomePageContent.Execute_with_intention_Title, content: HomePageContent.Execute_with_intention_Content },
  { img: lead, title: HomePageContent.Lead_with_Humility_Title, content: HomePageContent.Lead_with_Humility_Content },
  { img: passion, title: HomePageContent.Passion_and_Commitment_Title, content: HomePageContent.Passion_and_Commitment_Content },
];

const OurCoreValues = () => {
  return (
    <div className="our-core-values" id="our-core-values">
      <div className="our-core-values-content">
        <div className="our-core-values-title">
          {HomePageContent.our_Core_Values_Title}
        </div>

        {coreValuesData.map((value, index) => (
          <div
            className={`core-value-row ${index % 2 === 0 ? "normal" : "reverse"}`}
            key={index}
          >
            <div className="core-value-image">
              <img src={value.img} alt={value.title} />
            </div>
            <div className="core-value-text">
              <h3>{value.title}</h3>
              <p>{value.content}</p>
            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default OurCoreValues;
